import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { FormBuilder, FormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { parseCaseToWords } from '../../../../utils';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'frmg-download-report-dialog',
  templateUrl: './download-report-dialog.component.html',
  styleUrls: ['./download-report-dialog.component.scss'],
  imports: [MatRadioGroup, ReactiveFormsModule, FormsModule, MatRadioButton, MatFormField, MatSelect, MatOption, MatButton, MatDialogClose]
})
export class DownloadReportDialogComponent  {
  public isLoading = false;
  public format = 'xlsx';
  public metadataCtrl: FormControl;

  constructor(
    private dialogRef: MatDialogRef<DownloadReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder) {
    this.metadataCtrl = this.fb.control(this.data.selected);
  }


  public closeDialog(result: any): void {
    this.dialogRef.close(result);
  }

  public columnHeader(column: string) {
    switch (column) {
      case 'name':
        return 'Area Name';
      case 'exposure_value':
        return 'Exposure';
      case 'geometry_type':
        return 'AOI Type';
      case 'risk_percentage':
        return 'Risk Percentage';
      case 'action':
        return '';
      default:
        return parseCaseToWords(column.replace('metadata.', ''));
    }
  }

  public download(): void {
    this.isLoading = true;
    this.dialogRef.close({ meta: this.metadataCtrl.value, type: this.format });
  }
}
